import { useMutation } from 'react-query'
import { fetchDownloadAndInstall, FetchDownloadAndInstallParams, fetchInstallSnape, fetchRollback, fetchUpdateFirmware, FetchInstallSnapeParams, FetchUpdateFirmwareParams, fetchUploadFile, fetchRetryInstallation } from '../api'

export const useMutationInstallSnape = () => useMutation((params: FetchInstallSnapeParams) => fetchInstallSnape(params))

export const useMutationUpdateFirmware = () => useMutation((params: FetchUpdateFirmwareParams) => fetchUpdateFirmware(params))

export const useMutationDownloadAndInstall = () => useMutation((params: FetchDownloadAndInstallParams) => fetchDownloadAndInstall(params))

export const useMutationRollback = () => useMutation((params: {fileName: string, releaseType: string}) => fetchRollback(params))

export const useMutationUploadFile = () => useMutation((params: {formData: FormData}) => fetchUploadFile(params))


export const useMutationRetryInstallation = () => useMutation(() => fetchRetryInstallation())

